export const TAX_MAPS_FORM = 'taxMaps';
export const TAB_INDEX = '1000';
export const EMPTY_VALUE = '';

export enum SearchTypeFormNames {
  DRIVERS_SEARCH = 'driversSearch',
  HOB_CODES = 'hobCodes',
}

export enum LocationFormNames {
  COUNTY = 'hobCodes.countyHob',
  CITY = 'hobCodes.cityHob',
  VILLAGE = 'hobCodes.villageHob',
}

export enum PropertyFormLabels {
  COUNTY = 'County',
  CITY = 'Town',
  DRIVERS_SEARCH = 'Block Lot Search',
  VILLAGE = 'Village',
}

export enum PropertyFormPlaceholders {
  COUNTY = 'Choose County',
  CITY = 'All Towns',
  VILLAGE = 'All Villages',
}

export enum USStateCodes {
  NY = 'NY',
  NJ = 'NJ',
}

export const TAX_MAPS_FORM_INITIAL_VALUES = {
  [SearchTypeFormNames.HOB_CODES]: {
    countyHob: EMPTY_VALUE,
    cityHob: EMPTY_VALUE,
    villageHob: EMPTY_VALUE,
  },
  [SearchTypeFormNames.DRIVERS_SEARCH]: {},
};

export const COLUMN_NAMES = {
  taxMapImageId: { title: 'File Download', dataIndex: 'taxMapImageId' },
};
